import { darken, ThemeOptions } from "@mui/material/styles";

import { getInvertColor } from "utils/themeUtils";

export const linearProgressOverrides: ThemeOptions["components"] = {
	MuiLinearProgress: {
		styleOverrides: {
			root: ({ theme }) => ({
				height: theme.spacing(2),
				borderRadius: theme.spacing(4),
				backgroundColor: theme.palette.dirtyWhite["400"],
			}),

			bar: ({ theme }) => {
				const isLight = getInvertColor(theme.palette.primary.main) === theme.palette.dirtyWhite["2000"];

				return {
					borderRadius: theme.spacing(4),
					backgroundColor: isLight ? darken(theme.palette.primary.main, 0.5) : theme.palette.primary.main,
				};
			},
		},
	},
};
